import { Orders } from "../pages/orders/Orders";
import { Customers } from "../pages/users/Customers";
import { Shops } from "../pages/shops/Shops";
import { Dashboard } from "../pages/Dashboard";
import { Categories } from "../pages/categories/Categories";
import { Staff } from "../pages/Staff";
import { Notifications } from "../pages/notifications/Notifications";
import { Products } from "../pages/products/Products";
import { OrderDetails } from "../pages/orders/OrderDetails";
import { LandingPage } from "../pages/landing/LandingPage";
import Login from "../pages/Login";
import { ClientTicketForm } from "../pages/tickets/ClientTicketForm";
import { AccountDeletionForm } from "../pages/account-deletion/AccountDeletionForm";
import { PrivacyPolicy } from "../pages/privacy/PrivacyPolicy";
import { GenericRegister } from "../components/common/GenericRegister";
import { PaymentMethods } from "../pages/payment-methods/PaymentMethods";
import { ContactsForm } from "../pages/contacts/ContactsForm";
import { DownloadApp } from "../pages/download/DownloadApp";
import { VersionControlForm } from "../pages/version/VersionControlForm";

// external use
export const guestRoutes = [
  {
    path: "/admin",
    component: <Login />,
  },
  {
    path: "/",
    component: <LandingPage />,
  },
  {
    path: "/ticket/create",
    component: <ClientTicketForm />,
  },
  // DELETE USER ACCOUNT
  {
    path: "/delete-account",
    component: <AccountDeletionForm />,
  },
  // PRIVACY POLICY
  {
    path: "/privacy",
    component: <PrivacyPolicy />,
  },
  // DOWNLOAD
  {
    path: "download",
    component: <DownloadApp />,
  },
];

export const routes = [
  {
    path: "/",
    component: <Dashboard />,
  },
  // orders
  {
    path: "/orders",
    component: <Orders />,
  },
  {
    path: "/orders/details",
    component: <OrderDetails />,
  },
  {
    path: "/customers",
    component: <Customers />,
  },
  {
    path: "/staff",
    component: <Staff />,
  },
  {
    path: "/products",
    component: <Products />,
  },
  {
    path: "/shops",
    component: <Shops />,
  },
  {
    path: "/categories",
    component: <Categories />,
  },
  {
    path: "/notifications",
    component: <Notifications />,
  },
  {
    path: "/register/:source",
    component: <GenericRegister />,
  },
  {
    path: "/payment-methods",
    component: <PaymentMethods />,
  },
  {
    path: "/contacts",
    component: <ContactsForm />,
  },
  {
    path: "/version",
    component: <VersionControlForm />,
  },
];
